
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import "vue-datetime/dist/vue-datetime.css";
import moment from "moment";

@Component
export default class BookingRemoveConfirmation extends Vue {

    @Prop({default: false})
    public confirmBlock: boolean;

    @Prop({default: null})
    public booking: any;

    @Getter private currentUser: any;

    private loading: boolean = false;

    private deleteBooking() {
        if (!this.booking.id) {
            this.$store.commit("alerts/displayError", {
                msg: "Réservation introuvable",
            });
            this.$emit("closeModal");
        }
        this.loading = true;
        this.$store.dispatch("bookings/delete", {
            id: this.booking.id,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("alerts.planning.removeSuccess"),
            });
            this.$emit("removeSuccess");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
            this.$emit("closeModal");
        }).finally(() => {
            this.loading = false;
        });
    }
}
